import { Component } from '@angular/core';
import { SidebarNavMenuItem } from '../../../decorators/sidebar-nav-menu-item';


@SidebarNavMenuItem({
  route: '/customer-invoice',
  faIcon: 'fa-file-text',
  name: 'Customer Invoice',
  order:4005,
  roles:['admin']
})
@Component({
  selector: 'app-customer-invoice',
  templateUrl: './customer-invoice.component.html',
  styleUrl: './customer-invoice.component.css'
})
export class CustomerInvoiceComponent {

}
